<template>
  <div class='wrapper'>
    <navigator class='header' title="报修申请" :routePath='"/"'></navigator>
    <div class='body'>
      <div>
        <van-panel title="订单状态" :status="status[response.orderStatus]"/>
      </div>

      <van-panel title="订单详情" class="panelTitle">
        <van-cell-group class="panelInfo">
          <van-cell title="订单编号" :value="response.orderId" />
        </van-cell-group>
      </van-panel>

      <van-panel title="费用明细" :status="'总计：'+(response.orderFee/100)+'元'" class="panelTitle" v-if="orderMaterielList.length>0">
        <van-cell-group class="panelInfo" v-if="orderMaterielList.length>0">
          <div class="MaterieInfo" v-for="(item, index) in response.orderServiceInfo.orderMaterielList" :key="index">
            <p >{{ item.materielName }} （{{ item.num }}）：{{ item.fee / 100 | PriceFilter }} 元</p>
          </div>
          <p class="MaterieInfo" v-if="response.orderServiceInfo.bidRemark">备注说明：{{ response.orderServiceInfo.bidRemark}}</p>
        </van-cell-group>
      </van-panel>

      <van-panel title="表单信息" class="panelTitle">
        <van-cell-group class="panelInfo" v-if="response.orderServiceInfo">
          <van-cell v-for="(item,k) in response.orderServiceInfo.content" :key="k" :title="item.title" :value="item.value">
            <p v-if="item.type == 7">
              <van-swipe class="img_b" :autoplay="2000">
                <van-swipe-item v-for="(image, index) in getImgUrl(item.value)" :key="index">
                  <img class="img_b" v-lazy="image" @click="showImg(item.value, index)"/>
                </van-swipe-item>
              </van-swipe>
            </p>
          </van-cell>
        </van-cell-group>
      </van-panel>

      <van-panel title="申请人信息" class="panelTitle">
        <van-cell-group class="panelInfo">
          <van-cell title="联系人" :value="response.applyName" />
          <van-cell title="联系电话" :value="response.applyPhone" />
          <van-cell title="职位" :value="response.applyPosition" />
          <van-cell title="公司名称" :value="response.applyCorpName" />
        </van-cell-group>
      </van-panel>

      <van-panel title="订单操作记录" class="panelTitle" v-if="response.orderServiceInfo">
        <van-steps class="panelInfo" direction="vertical" :active="response.orderServiceInfo.orderOperateList.length-1" active-color="#d9262c">
          <van-step v-for="item in response.orderServiceInfo.orderOperateList" :key="item.operateId">
            <img class="user-icon" :src="item.userIcon">
            <p class="op-item">{{item.realName ? item.realName : item.userNick}}  {{item.title}}</p>
            <p class="op-item">{{new Date(item.createTime) | dateFormat}}</p>
            <p>{{item.remark}}</p>
          </van-step>
        </van-steps>
      </van-panel>

      <!--<van-panel title="服务评价" class="top bottom">-->
        <!--<van-cell title="评分" :value="response.applyCorpName" class="top" >-->
          <!--<rate :length="5" v-model="myRate" />-->
        <!--</van-cell>-->
      <!--</van-panel>-->

      <div class="top bottom">
        <div class="btn" v-if="response.orderStatus==2">
          <router-link :to="'/repairer/cancel/'+ response.orderId">
            <van-button type="danger" plain>取消订单</van-button>
          </router-link>
          <router-link :to="'/repairer/close/'+ response.orderId">
            <van-button type="danger" plain>&nbsp;退&nbsp;&nbsp;&nbsp;单&nbsp;</van-button>
          </router-link>
          <router-link :to="'/repairer/stuff/'+ response.orderId + '?unit_code=' + unitCode">
            <van-button type="danger">完工报价</van-button>
          </router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { Toast, ImagePreview } from 'vant';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      orderId: 0,
      unitCode: "",
      myRate: 3.5,
      status: ["删除","待审批","待报价","审批不通过","用户取消","待支付","完成","订单关闭","已退款","退款中"],
      response:{
        applyPosition: "--",
        applyName: "--",
        applyPhone: "--",
        orderId: "--",
        applyCorpName: "--",
        parkId: "67865757"
      },
      orderMaterielList:[],
    };
  },
  methods: {
    ...mapMutations(['change_currentParkId']),
    getInfo(){
      this.$http.post(`${this.URL_PREFIX}/app/get/maintain/order/detail/personnel`,{
        orderId: this.orderId
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode == 10000){
          this.response = res.data.resData;
          this.change_currentParkId(this.response.orderParkId);
          this.unitCode = this.response.unitCode;
          this.orderMaterielList = this.response.orderServiceInfo.orderMaterielList;
        }else{
          Toast(res.data.resDesc);
        }
      })
    },
    getImgUrl(value) {
      return typeof value === 'string' ? value.split(',') : [];
    },
    showImg(value, k) {
      let arrUrl = this.getImgUrl(value);
      ImagePreview(arrUrl, k);
    },
  },

  computed: {
    ...mapGetters(['token']),
  },

  filters: {
    dateFormat: (value) => {
      const date = new Date(value);
      const year = date.getFullYear();
      const month = date.getMonth()+1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  },

  mounted() {
    this.getInfo()
  },
  created() {
    this.orderId = this.$route.params.orderId;
  },
};
</script>


<style lang="scss" scoped>
@import "~@scss";
.panelTitle{
  margin-top: .133333rem;
  font-size: .453333rem;
  font-weight: bold;
  background-color: #fff;
}
.panelInfo{
  font-size: .4rem;
  font-weight: normal;
}
.MaterieInfo {
  padding: .2rem .32rem;
  p {
    color: rgb(153, 153, 153);
  }
}
.wrapper{
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: hsl(0, 0%, 94%);
  .body{
    background: #eee;
    margin-top: 8px;
    .top{
      margin-top: 8px;
    }
    .btn{
      margin-left: 13%;
    }
    .bottom{
      padding-bottom: 40px;
    }
    .img_b{
      width: 4rem;
      height: 3rem;
    }
  }
}
.user-icon{
  float: left;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
}
.op-item{
  padding-left: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/repairer/Repairer.vue